module.exports = "/images/avatar-s-2.jpg?fc2135e130e396cfc30cec9b6e9861af";